import React from "react"
import classes from "./OrderTotal.module.scss"
import {useAppSelector} from "../../../../../hooks/redux"
import numberFormat from "../../../../../utils/numberFormat"

interface IOrderTotalProps {
  className?: string
}

function OrderTotal({className}: IOrderTotalProps) {

  const {leads, complete, totalPrice} = useAppSelector(state => state.order)
  const cls = [classes.wrap, "styled-scroll"]

  if (className) {
    cls.push(className)
  }

  return (
    <div className={cls.join(" ")}>
      <div className={classes.item}>
        <div className={classes.name}>Общая стоимость за период</div>
        <div className={classes.value}>{numberFormat(totalPrice)} руб.</div>
      </div>
      <div className={classes.item}>
        <div className={classes.name}>Заявок завершено</div>
        <div className={classes.value}>{complete}</div>
      </div>
      <div className={classes.item}>
        <div className={classes.name}>Кол-во лидов</div>
        <div className={classes.value}>{leads}</div>
      </div>
    </div>
  )
}

export default OrderTotal